import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Arrow from '../../Icons/Arrow';
import * as styles from './style';
import { MAIN_COLOR } from '../../../styles/variables';
import { Checkbox } from '../../../styles/customComponents';

class Accordion extends Component {
  state = {
    isOpen: false,
  };

  componentDidMount = () => {
    this.openAccordion();
  };

  componentDidUpdate = (prevProps, prevState) => {
    this.openAccordion(prevState.isOpen);

    if (prevProps.isFiltering && !this.props.isFiltering) {
      this.setState({ isOpen: false });
    }
  };

  openAccordion = (isOpen = false) => {
    if (this.props.isFiltering && !isOpen) {
      this.setState({ isOpen: true });
    }
  };

  toggle = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  isAllChecked = () => {
    const { data } = this.props;
    return data.options.every(opt => opt.checked);
  };

  isSomeChecked = () => {
    const { data } = this.props;
    return data.options.some(opt => opt.checked);
  };

  render() {
    const { data, toggleParentItem, CustomItem, toggleItem, saleType, lastItem } = this.props;
    const arrowPosition = this.state.isOpen ? 'up' : 'down';

    return (
      <Fragment>
        <styles.Item id={`accordion-${data.id}`} lastItem={lastItem}>
          <styles.TitleAccordion>
            <styles.AccordionName>
              {toggleParentItem && (
                <Checkbox
                  id={`check-all-${data.id}`}
                  name={`check-all-${data.id}`}
                  checked={this.isAllChecked()}
                  someChecked={this.isSomeChecked()}
                  disabled={!!data.disabled}
                  onClick={!data.disabled ? () => toggleParentItem(data.id) : null}
                />
              )}
              <styles.Text>{data.name}</styles.Text>
            </styles.AccordionName>
            <styles.Button id={`accordion-toggle-${data.id}`} onClick={this.toggle}>
              <Arrow size={5} color={MAIN_COLOR} position={arrowPosition} />
            </styles.Button>
          </styles.TitleAccordion>
          <styles.SubItemWrapper isOpen={this.state.isOpen}>
            {data.options.map(option => (
              <CustomItem
                key={option.id}
                data={option}
                disabled={!!option.disabled}
                toggleItem={toggleItem}
                fatherId={data.id}
                saleType={saleType}
              />
            ))}
          </styles.SubItemWrapper>
        </styles.Item>
      </Fragment>
    );
  }
}

Accordion.propTypes = {
  data: PropTypes.object,
  select: PropTypes.func,
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/GenericList/Accordion/index.js